/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_WeekdaysInputs */

const de__field_weekdays = /** @type {(inputs: _Field_WeekdaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochentage`)
};

/**

* @param {_Field_WeekdaysInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_weekdays = /** @type {((inputs?: _Field_WeekdaysInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_WeekdaysInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_weekdays(inputs)
});